import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {useIntl} from 'react-intl'

export function JoinBrands() {
  const intl = useIntl()

  return (
    <section className='join-brands overflow-x-hidden'>
      <div className='container'>
        <div className='d-flex container-2 flex-column align-items-flex-start'>
          <h2 className='h2 raleway text-left mb-12'>
            {intl.formatMessage({id: 'JOIN_BRANDS_H2'})}
          </h2>
          <div className='d-flex flex-row align-items-center flex-wrap justify-content-evenly join-brands-container'>
            <img
              className='image-container'
              src={toAbsoluteUrl('/media/gori/integrations/customer-logos/mumu.svg')}
              alt='Mumu logo'
            />
            <img
              className='image-container'
              src={toAbsoluteUrl('/media/gori/integrations/customer-logos/cider.svg')}
              alt='Cider logo'
            />
            <img
              className='image-container'
              src={toAbsoluteUrl('/media/gori/integrations/customer-logos/yamato.svg')}
              alt='Yamato logo'
            />
            <img
              className='image-container'
              src={toAbsoluteUrl('/media/gori/integrations/customer-logos/wish.svg')}
              alt='Wish logo'
            />
            <img
              className='image-container'
              src={toAbsoluteUrl('/media/gori/integrations/customer-logos/postpony.svg')}
              alt='Postpony logo'
            />
            <img
              className='image-container'
              src={toAbsoluteUrl('/media/gori/integrations/customer-logos/vietnam-post.svg')}
              alt='Vietnam-post logo'
            />
          </div>
        </div>
      </div>
    </section>
  )
}
